import { render, staticRenderFns } from "./ViewEvent.vue?vue&type=template&id=05b8540c&"
import script from "./ViewEvent.vue?vue&type=script&lang=js&"
export * from "./ViewEvent.vue?vue&type=script&lang=js&"
import style0 from "./ViewEvent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ViewEvent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports